import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import store from "@/store"
import {loginParams} from "../common/query"

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login.vue"),
    meta:{title:"登录-统信账号｜Union ID"}
  },  
  {
    path:"/regist",
    name:"regist",
    component:() => import("@/views/regist.vue"),
    meta:{title:"注册-统信账号｜Union ID"}
  },
  {
    path:"/callback",
    name:"callback",
    component:() => import("@/views/callback.vue"),
    meta:{title:"正在跳转-统信账号｜Union ID"}
  },
  {
    path: "/",
    component: () => import("@/views/layouts/index.vue"),
    meta:{title:"首页-统信软件培训服务平台"},
    redirect:"/index",
    children:[
      {
        path:'/index',
        component:() => import("@/views/Index.vue"),
        meta:{title:"首页-统信软件培训服务平台"}
      },
      {
        path:'/course',
        component:() => import("@/views/train_certifications/courses/index.vue"),
        meta:{title:"课程体系-统信软件培训服务平台"},
        children:[
          {
            path:'/coursedetail',
            component:() => import("@/components/CourseDetail.vue"),
            meta:{title:"课程体系-统信软件培训服务平台"}
          },
        ]
      },
      {
        path:'/exam_appointment',
        component:() => import("@/views/exam_appointment/index.vue"),
        meta:{title:"认证体系-考试预约"}
      },
      {
        path:'/equis',
        component:() => import("@/views/train_certifications/equis/index.vue"),
        meta:{title:"认证体系-统信软件培训服务平台"}
      },
      {
        path:'/uos_course',
        component:() => import("@/views/train_certifications/uos_course/index.vue"),
        meta:{title:"UOS认证课程体系"}
      },
      {
        path:'/activity_scheduling',
        component:() => import("@/views/train_certifications/activity_scheduling/index.vue"),
        meta:{title:"培训活动排期"}
      },
      {
        path:'/openEuler',
        component:() => import("@/views/train_certifications/open_euler/index.vue"),
        meta:{title:"认证体系-统信软件培训服务平台"}
      },
      {
        path:'/openEulerTest',
        component:() => import("@/views/train_certifications/open_euler_test/index.vue"),
        meta:{title:"认证考试模拟练习-统信软件培训服务平台"}
      },
      {
        path:'/learnonline',
        component:() => import("@/views/t_x_class/learn_onlines/index.vue"),
        meta:{title:"在线学习-统信软件培训服务平台"}
      },
      {
        path:'/partners',
        component:() => import("@/views/t_x_class/partners/index.vue"),
        meta:{title:"合作伙伴-统信软件培训服务平台"},
        children:[
          {
            path:'/proxy',
            component:() => import("@/views/t_x_class/partners/proxy.vue"),
            meta:{title:"合作伙伴代理-统信软件培训服务平台"}
          },
        ]
      },
      {
        path:'/arrange',
        component:() => import("@/views/t_x_class/partners/arrange.vue"),
        meta:{title:"合作伙伴分布-统信软件培训服务平台"}
      },
      {
        path:'/testarea',
        component:() => import("@/views/t_x_class/test_areas/index.vue"),
        meta:{title:"考点分布-统信软件培训服务平台"}
      },
      {
        path:'/queryresults',
        component:() => import("@/views/result_certificates/query_results/index.vue"),
        meta:{title:"查询-统信软件培训服务平台"}
      },
      {
        path:'/checkcertificate',
        component:() => import("@/views/result_certificates/check_certificates/index.vue"),
        meta:{title:"证书验真-统信软件培训服务平台"}
      },
      {
        path:'/txcollege',
        component:() => import("@/views/t_x_colleges/index.vue"),
        meta:{title:"统信软件教育与考试中心-统信软件培训服务平台"}
      },
      {
        path:'/newscenter',
        component:() => import("@/views/news_centers/index.vue"),
        meta:{title:"资讯中心-统信软件培训服务平台"}
      },
      {
        path:'/newsdetail',
        component:() => import("@/components/newsDetails/NewsDetail.vue"),
        meta:{title:"资讯详情-统信软件培训服务平台"}
      },
      {
        path:'/root',
        component:() => import("@/views/user_centers/index.vue"),
        meta:{title:"用户中心-统信软件培训服务平台"},
        children:[
          {
            path:'/mycourse',
            component:() => import("@/views/user_centers/my_courses/index.vue"),
            meta:{title:"我的课程-统信软件培训服务平台"}
          },
          {
            path:'/myexam',
            component:() => import("@/views/user_centers/my_exams/index.vue"),
            meta:{title:"我的考试-统信软件培训服务平台"}
          },
        ]
      },
      {
        path:'/faculty',
        component:() => import("@/views/faculty_teams/index.vue"),
        meta:{title:"师资团队-统信软件培训服务平台"}
      },
      {
        path:'/facdetail',
        component:() => import("@/components/facultyDetail/FacultyDetail.vue"),
        meta:{title:"师资团队-统信软件培训服务平台"}
      },
    ]
  },
  {
    path:"/timeout",
    name:"timeout",
    component:() => import("@/views/timeout.vue"), 
    meta:{title:"资源请求失败"}
  },
  {
    path:"/404",
    name:"notFound",
    component:() => import("@/views/notFound.vue"),
    meta:{title:"找不到网页"}
  },
  {
    path:"/:catchAll(.*)",
    redirect:'/404'
    
  },
];

const router = createRouter({
  //本地环境和生产环境
  history: createWebHistory(),
  routes
});

router.beforeEach((to,from,next)=>{
  if(to.path!="/callback"){
  store.dispatch('set_status',to.path)
  localStorage.setItem('state',to.fullPath)
  }
  if (to.path=="/queryresults"){  // // 要去的是查询成绩证书页面，需要判断是否登录了，登录了才可以访问
    store.dispatch('user/selectUserInfo')
    if(localStorage.getItem("userinfo")){  // 登录了！
      //@ts-ignore
        document.title = to.meta.title
        next();
    }else{ // 没有登录就想访问是直接跳转到登录页面！
      let state1 = localStorage.getItem('state')?JSON.stringify(localStorage.getItem('state')):''
      console.log("这是state1",state1);
       let state = state1.substr(1,state1.length-2)
      const url = loginParams.AuthUrl+"?client_id="+loginParams.clientID+"&redirect_uri="+loginParams.CallBackUrl+"&response_type=code&scope="+loginParams.scope+"&state="+state;
      location.href = url
    }
  }
  else{  // 不是查询页面
    //@ts-ignore
    document.title = to.meta.title
    next()
  }
})

// 跳转后返回顶部
router.afterEach((to,from,next) => {
  
  window.scrollTo(0,0);
})

export default router;
